/**
 * This function computes the differences between two arrays of primitive types.
 *
 * It returns an object containing two arrays:
 * - `firstToSecond`: elements present in the first array but not in the second.
 * - `secondToFirst`: elements present in the second array but not in the first.
 */
export const computeDiffs = <T extends number | string>(first: T[], second: T[]) => {
  // Create sets for both arrays to optimize lookups.
  // Using a Set allows for O(1) average time complexity for lookups, so the whole function complexity is O(n).
  // This is particularly useful for large arrays.
  const firstSet = new Set(first);
  const secondSet = new Set(second);

  return {
    firstToSecond: first.filter(id => !secondSet.has(id)),
    secondToFirst: second.filter(id => !firstSet.has(id)),
  };
};
